import { useState } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { Leaf, Loader2 } from "lucide-react";
import { useAuth, fmtErr } from "@/context/AuthContext";

export default function Login() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/account";
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const u = await login(email, password);
      nav(u.role === "admin" ? "/admin/dashboard" : next);
    } catch (e2) {
      setErr(fmtErr(e2.response?.data?.detail, "Invalid email or password"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="login-page" className="mx-auto flex min-h-[70vh] max-w-md flex-col justify-center px-5 py-16">
      <img src="/logo-bins-plus.png" alt="Bins Plus Pressure Washing" className="h-14 w-14 object-contain" />
      <h1 className="mt-5 font-heading text-3xl font-extrabold tracking-tight">Welcome back</h1>
      <p className="mt-2 text-muted-foreground">Log in to manage your subscription and rebook faster.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="login-email" type="email" required placeholder="Email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        <input data-testid="login-password" type="password" required placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-xl border border-border bg-muted/50 px-4 py-3 focus:bg-card focus:outline-none focus:ring-2 focus:ring-primary" />
        {err && <p data-testid="login-error" className="text-sm font-semibold text-destructive">{err}</p>}
        <button data-testid="login-submit" type="submit" disabled={busy}
          className="inline-flex w-full items-center justify-center gap-2 rounded-xl bg-primary px-7 py-3.5 font-bold text-primary-foreground transition-all hover:brightness-110 disabled:opacity-50">
          {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : "Log In"}
        </button>
      </form>
      <p className="mt-6 text-center text-sm text-muted-foreground">
        New here?{" "}
        <Link to={`/signup?next=${encodeURIComponent(next)}`} className="font-semibold text-primary hover:underline">
          Create an account
        </Link>
      </p>
    </div>
  );
}
